import { render } from "./sub-company.vue?vue&type=template&id=654eac79&scoped=true"
import script from "./sub-company.vue?vue&type=script&lang=js"
export * from "./sub-company.vue?vue&type=script&lang=js"

import "./sub-company.vue?vue&type=style&index=0&id=654eac79&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654eac79"]])

export default __exports__